import { CaseDocumentsSagas } from "./CaseDocuments";

export default [...CaseDocumentsSagas];